import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-wrapper" }

import { storeToRefs } from 'pinia';
import { useCommonStore } from '@/store/common';
import AppHeader from '@/components/common/AppHeader/AppHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateApp',
  setup(__props) {

const { isMobile } = storeToRefs(useCommonStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-template d-flex flex-column", {'app-template--mobile': _unref(isMobile) }])
  }, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})